<app-template>

    <!-- FAD MASIVO DESKTOP -->
    <div class="fad-desktop" *ngIf="isMobile === false  && isTablet === false">
        <div class="container-privacy">
            <div class="header-privacy">
                <h1><p>
                    POLÍTICA DE SEGURIDAD DE LA INFORMACIÓN
                </p></h1>
            </div>
            <div class="privacy-content">
                <p class="date">
                    Fecha de última actualización: 30 de abril de 2019
                </p>
                <p>
                    <span>Propósito</span>
                    <br><br>
                    Esta política articula requisitos que asisten a la Gerencia General en la definición de una
                    estructura que establece un ambiente seguro. Proporciona el marco general para salvaguardar los
                    Recursos de Tecnología de la Información (TI), logrando la confidencialidad, integridad y
                    disponibilidad de los datos y recursos de TI utilizados en la prestación del servicio FAD (Firma
                    Autógrafa Digital).<br><br>
                    Todas las áreas de NA-AT Technologies buscan cumplir con los objetivos generales de seguridad de la
                    información de la empresa, incluyendo el cumplimiento de las leyes, reglamentos, políticas y
                    estándares a los que están sujetos sus datos y recursos tecnológicos.<br><br>
                    <span>Alcance de la Política de Seguridad de la Información</span><br><br>
                    Todos los empleados de NA-AT Technologies deben cumplir con esta política.<br><br>
                    Todas las áreas de NA-AT Technologies están obligadas a garantizar el cumplimiento de esta política
                    por parte de cualquier socio comercial que acceda a los Recursos de TI de la empresa, activos de
                    información o entornos compartidos para la prestación del servicio FAD (Firma Autógrafa
                    Digital).<br><br>
                    Todas las áreas de NA-AT Technologies están obligadas a velar por el cumplimiento de esta política
                    por parte de los proveedores y terceros que, por relación contractual, accedan a Recursos TI,
                    activos de información o entornos compartidos de la empresa para la prestación del servicio FAD
                    (Firma Autógrafa Digital).<br><br>
                    <span>Declaración de política de seguridad de la información</span><br><br>
                    A través de esta política, NA-AT Technologies reitera su compromiso con la seguridad de la
                    información y establece el enfoque de la organización para gestionar la seguridad de la información
                    en consonancia con su estrategia y objetivos comerciales, para lo cual:<br>
                </p>
                <ol>
                    <li>Establece la alineación con su estrategia y objetivos comerciales.</li>
                    <li>Establece y aprueba los criterios de aceptación del riesgo, así como la forma de gestionarlo.
                    </li>
                    <li>Reconoce que los activos de información son esenciales para su funcionamiento y por lo tanto
                        necesitan ser adecuadamente protegidos, para lo cual proporciona los recursos necesarios para la
                        implementación de controles de seguridad.
                    </li>
                    <li>Supervisa la eficacia del Sistema de Gestión de la Seguridad de la Información para garantizar
                        la
                        mejora continua.
                    </li>
                    <li>Aprueba la capacitación y concientización en seguridad de la información.</li>
                    <li>Asegura el establecimiento de canales de comunicación para la difusión de políticas,
                        procedimientos
                        y medidas de seguridad.
                    </li>
                    <li>Vela por la identificación y el cumplimiento de las Leyes, Normas y Reglamentos aplicables al
                        negocio.
                    </li>
                    <li>Promueve el conocimiento y cumplimiento de esta política y todas aquellas que de ella se deriven
                        a
                        sus empleados internos y proveedores.
                    </li>
                    <br>
                </ol>
                <p>
                    <span>Política General de Seguridad de la Información</span><br><br>
                    Todos los que participamos en NA-AT Technologies estamos comprometidos a mejorar de manera
                    sistemática y continua para convertirnos en un aliado tecnológico de nuestros clientes, construyendo
                    relaciones de largo plazo basadas en la confianza, el beneficio mutuo y las mejores prácticas
                    comerciales, con una creciente conciencia ambiental y responsabilidad social.<br><br>
                    Sustentamos nuestros servicios en una cultura de calidad de personas, procesos y prácticas,
                    siguiendo los lineamientos de las normas nacionales e internacionales con pleno apego a las normas
                    vigentes.<br><br>
                    En NA-AT Technologies estamos comprometidos en asegurar que la confidencialidad, integridad y
                    disponibilidad de los activos de información bajo nuestra responsabilidad se preserven en el
                    ambiente de trabajo, especialmente los relacionados con nuestros clientes, asegurando el
                    cumplimiento de las políticas, procesos y procedimientos de la empresa. seguridad. Estamos
                    comprometidos a desarrollar, implementar, mantener y mejorar continuamente el Sistema de Gestión de
                    Seguridad de la Información (SGSI).
                </p>
                <br>
            </div>
            <br>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">
        <div class="box-container">
            <div class="box-img">
                <img class="img-prin" src="assets/images/m/telefonos.png">
            </div>

            <div class="content-res">
                <h1>Política de Seguridad de la Información</h1>
                <p class="text">
                    Fecha de última actualización: 30 de abril de 2019
                </p>
                <p class="text">
                    <span>Propósito</span>
                    <br><br>
                    Esta política articula requisitos que asisten a la Gerencia General en la definición de una
                    estructura que establece un ambiente seguro. Proporciona el marco general para salvaguardar los
                    Recursos de Tecnología de la Información (TI), logrando la confidencialidad, integridad y
                    disponibilidad de los datos y recursos de TI utilizados en la prestación del servicio FAD (Firma
                    Autógrafa Digital).<br><br>
                    Todas las áreas de NA-AT Technologies buscan cumplir con los objetivos generales de seguridad de la
                    información de la empresa, incluyendo el cumplimiento de las leyes, reglamentos, políticas y
                    estándares a los que están sujetos sus datos y recursos tecnológicos.<br><br>
                    <span>Alcance de la Política de Seguridad de la Información</span><br><br>
                    Todos los empleados de NA-AT Technologies deben cumplir con esta política.<br><br>
                    Todas las áreas de NA-AT Technologies están obligadas a garantizar el cumplimiento de esta política
                    por parte de cualquier socio comercial que acceda a los Recursos de TI de la empresa, activos de
                    información o entornos compartidos para la prestación del servicio FAD (Firma Autógrafa
                    Digital).<br><br>
                    Todas las áreas de NA-AT Technologies están obligadas a velar por el cumplimiento de esta política
                    por parte de los proveedores y terceros que, por relación contractual, accedan a Recursos TI,
                    activos de información o entornos compartidos de la empresa para la prestación del servicio FAD
                    (Firma Autógrafa Digital).<br><br>
                    <span>Declaración de política de seguridad de la información</span><br><br>
                    A través de esta política, NA-AT Technologies reitera su compromiso con la seguridad de la
                    información y establece el enfoque de la organización para gestionar la seguridad de la información
                    en consonancia con su estrategia y objetivos comerciales, para lo cual:<br>
                </p>
                <ol class="text">
                    <li>Establece la alineación con su estrategia y objetivos comerciales.</li>
                    <li>Establece y aprueba los criterios de aceptación del riesgo, así como la forma de gestionarlo.
                    </li>
                    <li>Reconoce que los activos de información son esenciales para su funcionamiento y por lo tanto
                        necesitan ser adecuadamente protegidos, para lo cual proporciona los recursos necesarios para la
                        implementación de controles de seguridad.
                    </li>
                    <li>Supervisa la eficacia del Sistema de Gestión de la Seguridad de la Información para garantizar
                        la
                        mejora continua.
                    </li>
                    <li>Aprueba la capacitación y concientización en seguridad de la información.</li>
                    <li>Asegura el establecimiento de canales de comunicación para la difusión de políticas,
                        procedimientos
                        y medidas de seguridad.
                    </li>
                    <li>Vela por la identificación y el cumplimiento de las Leyes, Normas y Reglamentos aplicables al
                        negocio.
                    </li>
                    <li>Promueve el conocimiento y cumplimiento de esta política y todas aquellas que de ella se deriven
                        a
                        sus empleados internos y proveedores.
                    </li>
                    <br>
                </ol>
                <p class="text">
                    <span>Política General de Seguridad de la Información</span><br><br>
                    Todos los que participamos en NA-AT Technologies estamos comprometidos a mejorar de manera
                    sistemática y continua para convertirnos en un aliado tecnológico de nuestros clientes, construyendo
                    relaciones de largo plazo basadas en la confianza, el beneficio mutuo y las mejores prácticas
                    comerciales, con una creciente conciencia ambiental y responsabilidad social.<br><br>
                    Sustentamos nuestros servicios en una cultura de calidad de personas, procesos y prácticas,
                    siguiendo los lineamientos de las normas nacionales e internacionales con pleno apego a las normas
                    vigentes.<br><br>
                    En NA-AT Technologies estamos comprometidos en asegurar que la confidencialidad, integridad y
                    disponibilidad de los activos de información bajo nuestra responsabilidad se preserven en el
                    ambiente de trabajo, especialmente los relacionados con nuestros clientes, asegurando el
                    cumplimiento de las políticas, procesos y procedimientos de la empresa. seguridad. Estamos
                    comprometidos a desarrollar, implementar, mantener y mejorar continuamente el Sistema de Gestión de
                    Seguridad de la Información (SGSI).
                </p>
            </div>

        </div>
    </div>

</app-template>
